import React, { useEffect, useState } from "react";
import api from "../../axiosConfig";
import { Container, Form, Button, Row, Col, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import StocCurentPickerModal from "../pickers/StocCurentPickerModal";

const CasariForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);

  const [formData, setFormData] = useState({
    doc_no: "",
    doc_date: new Date().toISOString().split("T")[0],
    angajat_id: "",
    motiv: "",
    details: [],
  });

  const [angajati, setAngajati] = useState([]);

  // For the product picker
  const [pickerShow, setPickerShow] = useState(false);
  const [activeRowIndex, setActiveRowIndex] = useState(null);

  useEffect(() => {
    // Load lookups
    api.get("/angajati/").then(res => setAngajati(res.data)).catch(console.error);

    if (isEdit) {
      api.get(`/obinv/casare/${id}`).then((res) => {
        setFormData({
          doc_no: res.data.doc_no || "",
          doc_date: res.data.doc_date || "",
          angajat_id: res.data.angajat_id || "",
          motiv: res.data.motiv || "",
          details: res.data.details || [],
        });
      }).catch(console.error);
    }
  }, [id, isEdit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDetailChange = (index, field, value) => {
    const newDetails = [...formData.details];
    newDetails[index][field] = value;
    setFormData((prev) => ({ ...prev, details: newDetails }));
  };

  const addDetail = () => {
    setFormData((prev) => ({
      ...prev,
      details: [
        ...prev.details,
        { bxpart_id: "", qty: 1, pret: 0 },
      ],
    }));
  };

  const removeDetail = (index) => {
    const newDetails = formData.details.filter((_, i) => i !== index);
    setFormData((prev) => ({ ...prev, details: newDetails }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...formData };
    
    if (!payload.angajat_id) {
      toast.error("Selectați angajatul!");
      return;
    }

    try {
      if (isEdit) {
        await api.put(`/obinv/casare/${id}`, payload);
        toast.success("Casare actualizată!");
      } else {
        await api.post("/obinv/casare/", payload);
        toast.success("Casare creată!");
      }
      navigate("/obinv/casare");
    } catch (error) {
      console.error(error);
      toast.error("Eroare la salvare!");
    }
  };

  return (
    <Container className="mt-4">
      <h2 className="text-danger">{isEdit ? "Editare Casare Ob. Inv." : "Adăugare Casare Ob. Inv."}</h2>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col md={3}>
            <Form.Group>
              <Form.Label>Număr Document</Form.Label>
              <Form.Control type="text" name="doc_no" value={formData.doc_no} onChange={handleChange} required />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Data</Form.Label>
              <Form.Control type="date" name="doc_date" value={formData.doc_date} onChange={handleChange} required />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Angajat (Cui i se casează obiectul?)</Form.Label>
              <Form.Select name="angajat_id" value={formData.angajat_id} onChange={handleChange} required>
                <option value="">-- Selectează Angajat --</option>
                {angajati.map(a => <option key={a.id} value={a.id}>{a.nume_prenume}</option>)}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={12}>
            <Form.Group>
              <Form.Label>Motivul Casării (ex: Uzură, Distrugere, Pierdere)</Form.Label>
              <Form.Control type="text" name="motiv" value={formData.motiv} onChange={handleChange} />
            </Form.Group>
          </Col>
        </Row>

        <h4>Obiecte Casate</h4>
        <Table bordered size="sm">
          <thead>
            <tr>
              <th>Obiect (Produs)</th>
              <th>Cantitate</th>
              <th>Acțiuni</th>
            </tr>
          </thead>
          <tbody>
            {formData.details.map((detail, index) => (
              <tr key={index}>
                <td>
                  <Button 
                    variant="outline-secondary" 
                    size="sm"
                    onClick={() => {
                      setActiveRowIndex(index);
                      setPickerShow(true);
                    }}
                  >
                    {detail.bxpart_id ? (detail.cod + " - " + detail.denumire) : "Alege Produs..."}
                  </Button>
                </td>
                <td>
                  <Form.Control
                    type="number" step="0.01"
                    value={detail.qty}
                    onChange={(e) => handleDetailChange(index, "qty", e.target.value)}
                    required
                  />
                </td>
                <td>
                  <Button variant="danger" size="sm" onClick={() => removeDetail(index)}>Șterge</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Button variant="secondary" size="sm" onClick={addDetail} className="mb-3">
          + Adaugă Linie
        </Button>
        <br />
        <Button variant="danger" type="submit">Înregistrează Casarea</Button>
      </Form>

      {/* Modal pentru alegere produse */}
      <StocCurentPickerModal
        show={pickerShow}
        onHide={() => {
          setPickerShow(false);
          setActiveRowIndex(null);
        }}
        onPick={(picked) => {
          if (activeRowIndex !== null) {
            const newDetails = [...formData.details];
            const raw = picked.raw;
            newDetails[activeRowIndex] = {
              ...newDetails[activeRowIndex],
              bxpart_id: picked.id,
              cod: raw.cod,
              denumire: raw.denumire,
              qty: 1, 
              pret: raw.pret_magazie || 0
            };
            setFormData((prev) => ({ ...prev, details: newDetails }));
          }
        }}
      />
    </Container>
  );
};

export default CasariForm;
